import { render, staticRenderFns } from "./details-right-bottom.vue?vue&type=template&id=e198df1a&scoped=true&"
import script from "./details-right-bottom.vue?vue&type=script&lang=ts&"
export * from "./details-right-bottom.vue?vue&type=script&lang=ts&"
import style0 from "./details-right-bottom.vue?vue&type=style&index=0&id=e198df1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e198df1a",
  null
  
)

export default component.exports